export const PUBLIC_APP_ORIGIN = "https://app.envelaro.com";

export const TRIAL_SIGNUP_URL = `${PUBLIC_APP_ORIGIN}/portal?startTrial=1`;

export function planPurchaseUrl(planId: string) {
  return `${PUBLIC_APP_ORIGIN}/portal/onboarding?plan=${encodeURIComponent(planId)}`;
}

export function isAbsoluteHttpUrl(href: string) {
  return /^https?:\/\//i.test(href);
}
